import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const EnrollmentSuccess = () => {
  const { userDoc, family } = useAuth();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  const isParent = userDoc?.role === 'parent';
  const studentFirst = family?.studentName?.split(' ')[0] || 'your student';

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(c => {
        if (c <= 1) {
          clearInterval(timer);
          navigate('/');
        }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="screen screen--centered screen--no-nav">
      <div style={{ textAlign: 'center', maxWidth: 360 }}>
        {/* Animated checkmark */}
        <div style={circleStyle}>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <path
              d="M10 24l10 10 18-20"
              stroke="white"
              strokeWidth="3.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ animation: 'drawCheck 0.5s ease 0.3s forwards', strokeDasharray: 50, strokeDashoffset: 50 }}
            />
          </svg>
        </div>

        <style>{`
          @keyframes drawCheck {
            to { stroke-dashoffset: 0; }
          }
          @keyframes popIn {
            0% { transform: scale(0.5); opacity: 0; }
            70% { transform: scale(1.1); }
            100% { transform: scale(1); opacity: 1; }
          }
        `}</style>

        <h1 style={{ fontSize: '1.875rem', marginTop: 28, marginBottom: 12 }}>
          {isParent ? `${studentFirst}'s wallet is live!` : 'You\'re all set!'}
        </h1>

        <p style={{ color: 'var(--color-text-2)', lineHeight: 1.6, marginBottom: 40 }}>
          {isParent
            ? `Once ${studentFirst} accepts the invite, you'll both be able to track spending and savings together.`
            : `Your wallet is connected. Start tracking your spending and watch your savings grow.`}
        </p>

        <div className="card--accent" style={{ marginBottom: 32, padding: '16px 20px' }}>
          <p style={{ fontSize: '0.9rem', color: 'var(--color-primary)', fontWeight: 500 }}>
            {isParent
              ? `📱 Don't forget to add this app to your home screen for quick access`
              : `📱 Add this app to your home screen so it's always one tap away`}
          </p>
        </div>

        <button
          className="btn btn--primary btn--full btn--lg"
          onClick={() => navigate('/')}
        >
          Go to Dashboard
        </button>

        <p style={{ marginTop: 16, fontSize: '0.8125rem', color: 'var(--color-text-3)' }}>
          Redirecting in {countdown}s...
        </p>
      </div>
    </div>
  );
};

const circleStyle = {
  width: 96,
  height: 96,
  borderRadius: '50%',
  background: 'var(--color-primary)',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: '0 8px 32px rgba(45,106,79,0.35)',
  animation: 'popIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards',
};

export default EnrollmentSuccess;
